import { render, staticRenderFns } from "./CommissionsDetails.vue?vue&type=template&id=bd481b24&"
import script from "./CommissionsDetails.vue?vue&type=script&lang=js&"
export * from "./CommissionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports